import { IId } from '~/src/figure/Item';
import { P2 } from '~/src/geometry/point';
import * as Pnt from '~/src/geometry/point';
import * as Vec from '~/src/geometry/vector';
import { set , get1 } from '~/src/base/Optic';

import { direction, Ruler } from '~/src/figure/Ruler';

import { getRuler } from './Utils';
import State from '../State';
import * as St from '../State';


export interface MoveRuler {
	tag : 'MoveRuler';
	rid : IId;
	pnt : P2;
}

export const moveRuler = ( rid : IId , pnt : P2 ) : MoveRuler =>
	( { tag : 'MoveRuler' , rid , pnt } );

export const exeMoveRuler = ( state : State , cmd : MoveRuler ) : State => {
	const zoom : number = get1( St.zoom )( state );
	const ruler : undefined | Ruler = getRuler( cmd.rid )( state.figure );
	const project = St._project( get1( St.angle )( state ) );
	const normalize = St._normalize( get1( St.pan )( state ) )( zoom );

	if ( !ruler ) return state;

	const layer_offset = project( Pnt.p( direction( 32 / zoom )( ruler ) ) );
	const left = project( ruler.For.Left );
	const target = normalize( Pnt.p( cmd.pnt ) );
	const layers = Vec.firstBasis( Vec.sub( target )( left ) )( layer_offset );

	return set( St.rulerLayer( cmd.rid ) )( layers )( state );
};
